// These are used as feature flags
export enum OrgPermission {
  Apideck = 'apideck',
  GeminiModels = 'geminiModels',
  RelativityUsage = 'relativityUsage',
  AdminApproval = 'adminApproval',
  Require2FANonSSO = 'require2faNonSSO',
  Feedback = 'feedback',
  UsePropelAdminRoleAsDefault = 'usePropelAdminRoleAsDefault',
  KimFileUpload = 'kimFileUpload',
  MentionFolders = 'mentionFolders',
  ProceduralTimelines = 'proceduralTimelines',
}

export interface OrgPermissionConfig {
  id: string;
  permission: OrgPermission;
  title: string;
  description: string;
}

export const ORG_PERMISSION_CONFIGS: readonly OrgPermissionConfig[] = [
  {
    id: 'api-deck-toggle',
    permission: OrgPermission.Apideck,
    title: 'Apideck Integration',
    description: 'Whether the Apideck integration is enabled for this organisation.',
  },
  {
    id: 'gemini-toggle',
    permission: OrgPermission.GeminiModels,
    title: 'Gemini Models',
    description: 'Whether or not Gemini models are enabled for this organisation.',
  },
  {
    id: 'admin-approval-toggle',
    permission: OrgPermission.AdminApproval,
    title: 'Admin Approval',
    description: 'Whether the admin approval feature is enabled for this organisation.',
  },
  {
    id: 'require-2fa-toggle',
    permission: OrgPermission.Require2FANonSSO,
    title: 'Require 2FA non-SSO users',
    description:
      'Require non-SSO users to enable two-factor authentication before accessing the platform.',
  },
  {
    id: 'feedback-toggle',
    permission: OrgPermission.Feedback,
    title: 'In-app feedback',
    description: 'Whether the in-app feedback pop-ups are enabled for this organisation.',
  },
  {
    id: 'relativity-usage-toggle',
    permission: OrgPermission.RelativityUsage,
    title: 'Relativity Integration',
    description: 'Whether the Relativity integration is enabled for this organisation.',
  },
  {
    id: 'use-propel-admin-role-as-default-toggle',
    permission: OrgPermission.UsePropelAdminRoleAsDefault,
    title: 'Use Propel admin role as default',
    description:
      'When enabled, users added via PropelAuth with the Admin role are assigned the Administrator role in Wexler. When disabled, all new users get the default role.',
  },
  {
    id: 'kim-file-upload-toggle',
    permission: OrgPermission.KimFileUpload,
    title: 'Kim file upload',
    description: 'Whether the Kim file upload feature is enabled for this organisation.',
  },
  {
    id: 'mention-folders-toggle',
    permission: OrgPermission.MentionFolders,
    title: 'Mention folders',
    description: 'Whether users can mention folders when asking Kim questions.',
  },
];
